<template>
  <v-dialog v-model="dialog" max-width="450">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded                
        color="error"
        title="Remover experiência"
        v-on="on"
        v-bind="attrs"
        icon
        ><v-icon>mdi-delete-outline</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">Remover experiência</v-card-title>
      <v-card-text>
        Confirma a exclusão da experiência profissional
        {{ experiencia.cargo }} na empresa {{ experiencia.empresa }} ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded text color="error" @click="removerExp()"
          >Sim, remover</v-btn
        >
        <v-btn rounded text @click="dialog = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    experiencia: { type: Object, required: true },
  },
  computed: mapState(["candidato"]),
  data: () => ({
    dialog: false,
  }),
  methods: {
    removerExp() {
      
      var pos = this.candidato.experienciasprofissionais.findIndex((exp) => exp.id == this.experiencia.id)
      if(pos >= 0) this.candidato.experienciasprofissionais.splice(pos,1)

      this.dialog = false;
    },
  },
};
</script>

<style>
</style>